import { ShoppingCartResponse } from "@springtree/eva-services-core";
import { atom } from "jotai";

/**
 * Shopping cart state
 */
export const shoppingCartAtom = atom<ShoppingCartResponse | undefined>(undefined);

/**
 * Shopping cart request (OrderID)
 */
export const shoppingCartRequestAtom = atom<{ OrderID?: string } | undefined>(undefined);

/**
 * Loading state for cart operations
 */
export const isLoadingCartAtom = atom<boolean>(false);

/**
 * Starting state for cart: true until order retrieval failed or cart loading is finished
 */
export const isPendingCartAtom = atom<boolean>(true);
